import { useForm } from "react-hook-form";
import React, { useEffect, useRef, useState } from "react";

import { BASE_URL } from "../../constants/requests";
import Layout from "../../components/layout";

const REQUEST_URL = `${BASE_URL}/accounts/reset_password`;

function ResetPassword() {
    const [done, setDone] = useState(false);
    const [netError, setNetError] = useState("");
    const [working, setWorking] = useState(false);
    const {
        formState: { errors },
        getValues,
        handleSubmit,
        register,
        reset,
        setError
    } = useForm();

    const email = useRef(null);
    const emailState = errors.email ? "uk-form-danger" : "";

    useEffect(() => {
        email.current = getValues("email");

        reset();
    }, [done, email, getValues, reset]);

    const onSubmit = async data => {
        try {
            setNetError("");
            setWorking(true);

            const response = await fetch(REQUEST_URL, {
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json"
                },
                method: "PUT"
            });

            if (response.status === 204) {
                setDone(true);
            } else {
                setError("email", { message: "Invalid email address. Please try again", type: "net" });
            }
        } catch (error) {
            setNetError(error.message);
        } finally {
            setWorking(false);
        }
    };

    const renderDone = () => (
        <div className="uk-text-center">
            <h3>We sent a password recovery link to {email.current}.</h3>
        </div>
    );

    const renderForm = () => (
        <form className="uk-form-stacked" onSubmit={handleSubmit(onSubmit)}>
            <fieldset className="uk-fieldset">
                <h3>Reset Password</h3>

                {netError && <div className="uk-alert uk-alert-danger">{netError}</div>}

                <div className="uk-margin">
                    <label className="uk-form-label" htmlFor="email">
                        Email Address
                    </label>

                    <div className="uk-form-controls">
                        <input
                            className={`uk-input uk-form-large ${emailState}`}
                            id="email"
                            type="email"
                            {...register("email", { required: "Email address is required" })}
                        />
                        {errors.email && <div className="uk-text-danger">{errors.email.message}</div>}
                    </div>
                </div>

                <div className="uk-margin">
                    <button
                        className="button-pink uk-button uk-button-primary"
                        disabled={working}
                        style={{ width: "320px" }}
                        type="submit"
                    >
                        {working ? "Working..." : "Send Recovery Link"}
                    </button>
                </div>
            </fieldset>
        </form>
    );

    return (
        <Layout className="uk-margin-large" style={{ height: "470px" }}>
            <div className="uk-section">
                <div className="uk-container uk-container-medium">{done ? renderDone() : renderForm()}</div>
            </div>
        </Layout>
    );
}

export default ResetPassword;
